function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BoundaryNodeRule from '../algorithm/BoundaryNodeRule';
import GeometryGraph from '../geomgraph/GeometryGraph';
import RobustLineIntersector from '../algorithm/RobustLineIntersector';
var GeometryGraphOperation = /*#__PURE__*/function () {
  function GeometryGraphOperation() {
    _classCallCheck(this, GeometryGraphOperation);
    GeometryGraphOperation.constructor_.apply(this, arguments);
  }
  return _createClass(GeometryGraphOperation, [{
    key: "getArgGeometry",
    value: function getArgGeometry(i) {
      return this._arg[i].getGeometry();
    }
  }, {
    key: "setComputationPrecision",
    value: function setComputationPrecision(pm) {
      this._resultPrecisionModel = pm;
      this._li.setPrecisionModel(this._resultPrecisionModel);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryGraphOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { GeometryGraphOperation as default };
GeometryGraphOperation.constructor_ = function () {
  this._li = new RobustLineIntersector();
  this._resultPrecisionModel = null;
  this._arg = null;
  if (arguments.length === 1) {
    var g0 = arguments[0];
    this.setComputationPrecision(g0.getPrecisionModel());
    this._arg = new Array(1).fill(null);
    this._arg[0] = new GeometryGraph(0, g0);
  } else if (arguments.length === 2) {
    var _g = arguments[0];
    var g1 = arguments[1];
    GeometryGraphOperation.constructor_.call(this, _g, g1, BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE);
  } else if (arguments.length === 3) {
    var _g2 = arguments[0];
    var _g3 = arguments[1];
    var boundaryNodeRule = arguments[2];
    if (_g2.getPrecisionModel().compareTo(_g3.getPrecisionModel()) >= 0) this.setComputationPrecision(_g2.getPrecisionModel());else this.setComputationPrecision(_g3.getPrecisionModel());
    this._arg = new Array(2).fill(null);
    this._arg[0] = new GeometryGraph(0, _g2, boundaryNodeRule);
    this._arg[1] = new GeometryGraph(1, _g3, boundaryNodeRule);
  }
};